import type { ChoiceItem } from "./choice";

type Props = {
  items: ChoiceItem[];
  onSelect: (id: string) => void;
};

export function SelectField(props: Props) {
  const selected = props.items.find((item) => item.selected)?.id ?? "";

  return (
    <div className="select-field relative">
      <select
        className="select-field__control w-full appearance-none"
        value={selected}
        onChange={(event) => props.onSelect(event.target.value)}
      >
        {props.items.map((item) => (
          <option
            key={item.id}
            className="select-field__option"
            value={item.id}
          >
            {item.label}
          </option>
        ))}
      </select>
      <div
        className="select-field__chevron pointer-events-none absolute"
        aria-hidden="true"
      >
        <svg
          className="select-field__chevron-icon"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            className="select-field__chevron-path"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    </div>
  );
}
